const PROPERTY_LOCATION_PREFIX = 'propertylocation';
const MAILING_ADDRESS_PREFIX = 'mailingaddress';

export function getSectionFromKey(fieldKey) {
  if (!fieldKey) return null;
  const key = String(fieldKey).toLowerCase().replace(/[\s_\-.]/g, '');
  if (key.includes(MAILING_ADDRESS_PREFIX)) return 'mailing';
  if (key.includes(PROPERTY_LOCATION_PREFIX)) return 'property';
  return null;
}

export function getAddressPlaceholder({ role, section }) {
  if (!role || !section) return '';
  
  const sectionLabel = section === 'property' ? 'Property' : 'Mailing';
  const roleLabel = String(role).charAt(0).toUpperCase() + String(role).slice(1).toLowerCase();
  
  return `${sectionLabel} ${roleLabel}`;
}
